export const PHONE = '8000742'
export const PHONE_LINK = `tel:${PHONE}`
